<div class="container">
  <div
    class="offset-sm-1 col-sm-10 pt-5 webview text-center"
    [@flyInOut]="'in'"
  >
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">
      {{ question }}
    </h1>
    <div class="col-sm-6 col-md-6 col-xl-6 m-auto text-left">
      <label class="custom-control custom-checkbox chkbox mb-2" for="upgrade1">
        <input
          type="checkbox"
          class="custom-control-input mgntp10"
          id="upgrade1"
          value="hgUpgrades.upgrade1"
          [(ngModel)]="hgUpgrades.upgrade1"
          name="upgrade"
          (ngModelChange)="
            getGradeType(
              'Replacement / double-paned windows',
              hgUpgrades.upgrade1
            )
          "
        />
        <label class="custom-control-label font20" for="upgrade1"
          >Replacement / double-paned windows</label
        >
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="upgrade2">
        <input
          type="checkbox"
          class="custom-control-input mgntp10"
          id="upgrade2"
          value="hgUpgrades.upgrade2"
          [(ngModel)]="hgUpgrades.upgrade2"
          name="upgrade"
          (ngModelChange)="
            getGradeType('Caulking + weatherstripping', hgUpgrades.upgrade2)
          "
        />
        <label class="custom-control-label font20" for="upgrade2"
          >Caulking + weatherstripping</label
        >
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="upgrade3">
        <input
          type="checkbox"
          class="custom-control-input mgntp10"
          id="upgrade3"
          value="hgUpgrades.upgrade3"
          [(ngModel)]="hgUpgrades.upgrade3"
          name="upgrade"
          (ngModelChange)="
            getGradeType('Ceiling fans throughout', hgUpgrades.upgrade3)
          "
        />
        <label class="custom-control-label font20" for="upgrade3"
          >Ceiling fans throughout</label
        >
      </label>
      <label
        class="custom-control custom-checkbox chkbox mb-2"
        for="upgrade4"
        *ngIf="!propertyFlag"
      >
        <input
          type="checkbox"
          class="custom-control-input mgntp10"
          id="upgrade4"
          value="hgUpgrades.upgrade4"
          [(ngModel)]="hgUpgrades.upgrade4"
          name="upgrade"
          (ngModelChange)="
            getGradeType(
              'Added attic insulation (> 10&quot;)',
              hgUpgrades.upgrade4
            )
          "
        />
        <label class="custom-control-label font20" for="upgrade4"
          >Added attic insulation (> 10")</label
        >
      </label>
      <label
        class="custom-control custom-checkbox chkbox mb-2"
        for="upgrade5"
        *ngIf="!propertyFlag"
      >
        <input
          type="checkbox"
          class="custom-control-input mgntp10"
          id="upgrade5"
          value="hgUpgrades.upgrade5"
          [(ngModel)]="hgUpgrades.upgrade5"
          name="upgrade"
          (ngModelChange)="
            getGradeType('Radiant heat barrier', hgUpgrades.upgrade5)
          "
        />
        <label class="custom-control-label font20" for="upgrade5"
          >Radiant heat barrier</label
        >
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="upgrade6">
        <input
          type="checkbox"
          class="custom-control-input mgntp10"
          id="upgrade6"
          value="hgUpgrades.upgrade6"
          [(ngModel)]="hgUpgrades.upgrade6"
          name="upgrade"
          (ngModelChange)="
            getGradeType('Tankless / solar water heater', hgUpgrades.upgrade6)
          "
        />
        <label class="custom-control-label font20" for="upgrade6"
          >Tankless / solar water heater</label
        >
      </label>
      <label
        class="custom-control custom-checkbox chkbox mb-2"
        for="upgrade7"
        *ngIf="!propertyFlag"
      >
        <input
          type="checkbox"
          class="custom-control-input mgntp10"
          id="upgrade7"
          value="hgUpgrades.upgrade7"
          [(ngModel)]="hgUpgrades.upgrade7"
          name="upgrade"
          (ngModelChange)="getGradeType('Solar panels', hgUpgrades.upgrade7)"
        />
        <label class="custom-control-label font20" for="upgrade7"
          >Solar panels</label
        >
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="upgrade8">
        <input
          type="checkbox"
          class="custom-control-input mgntp10"
          id="upgrade8"
          value="hgUpgrades.upgrade8"
          [(ngModel)]="hgUpgrades.upgrade8"
          name="upgrade"
          (ngModelChange)="
            getGradeType('None of the above', hgUpgrades.upgrade8)
          "
        />
        <label class="custom-control-label font20" for="upgrade8"
          >None of the above</label
        >
      </label>
    </div>
    <p class="m-0 mb-2 text-muted tapmsg">{{ questionObj.chkboxtype }}</p>
    <button
      class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase"
      [ngClass]="{ sectbtn: user_bot }"
      (click)="next()"
    >
      Next
    </button>
  </div>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj._id">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width: 100%" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{ question }}</h1>
      </div>
    </div>
  </div>
  <div class="row col-sm-12 m-auto">
    <label
      class="custom-control custom-checkbox chkbox mb-2"
      for="upgrade1_mob"
    >
      <input
        type="checkbox"
        class="custom-control-input mgntp10"
        id="upgrade1_mob"
        value="hgUpgrades.upgrade1"
        [(ngModel)]="hgUpgrades.upgrade1"
        name="upgrade"
        (ngModelChange)="
          getGradeType(
            'Replacement / double-paned windows',
            hgUpgrades.upgrade1
          )
        "
      />
      <label class="custom-control-label font20" for="upgrade1_mob"
        >Replacement / double-paned windows</label
      >
    </label>
    <label
      class="custom-control custom-checkbox chkbox mb-2"
      for="upgrade2_mob"
    >
      <input
        type="checkbox"
        class="custom-control-input mgntp10"
        id="upgrade2_mob"
        value="hgUpgrades.upgrade2"
        [(ngModel)]="hgUpgrades.upgrade2"
        name="upgrade"
        (ngModelChange)="
          getGradeType('Caulking + weatherstripping', hgUpgrades.upgrade2)
        "
      />
      <label class="custom-control-label font20" for="upgrade2_mob"
        >Caulking + weatherstripping</label
      >
    </label>
    <label
      class="custom-control custom-checkbox chkbox mb-2"
      for="upgrade3_mob"
    >
      <input
        type="checkbox"
        class="custom-control-input mgntp10"
        id="upgrade3_mob"
        value="hgUpgrades.upgrade3"
        [(ngModel)]="hgUpgrades.upgrade3"
        name="upgrade"
        (ngModelChange)="
          getGradeType('Ceiling fans throughout', hgUpgrades.upgrade3)
        "
      />
      <label class="custom-control-label font20" for="upgrade3_mob"
        >Ceiling fans throughout</label
      >
    </label>
    <label
      class="custom-control custom-checkbox chkbox mb-2"
      for="upgrade4_mob"
      *ngIf="!propertyFlag"
    >
      <input
        type="checkbox"
        class="custom-control-input mgntp10"
        id="upgrade4_mob"
        value="hgUpgrades.upgrade4"
        [(ngModel)]="hgUpgrades.upgrade4"
        name="upgrade"
        (ngModelChange)="
          getGradeType(
            'Added attic insulation (> 10&quot;)',
            hgUpgrades.upgrade4
          )
        "
      />
      <label class="custom-control-label font20" for="upgrade4_mob"
        >Added attic insulation (> 10")</label
      >
    </label>
    <label
      class="custom-control custom-checkbox chkbox mb-2"
      for="upgrade5_mob"
      *ngIf="!propertyFlag"
    >
      <input
        type="checkbox"
        class="custom-control-input mgntp10"
        id="upgrade5_mob"
        value="hgUpgrades.upgrade5"
        [(ngModel)]="hgUpgrades.upgrade5"
        name="upgrade"
        (ngModelChange)="
          getGradeType('Radiant heat barrier', hgUpgrades.upgrade5)
        "
      />
      <label class="custom-control-label font20" for="upgrade5_mob"
        >Radiant heat barrier</label
      >
    </label>
    <label
      class="custom-control custom-checkbox chkbox mb-2"
      for="upgrade6_mob"
    >
      <input
        type="checkbox"
        class="custom-control-input mgntp10"
        id="upgrade6_mob"
        value="hgUpgrades.upgrade6"
        [(ngModel)]="hgUpgrades.upgrade6"
        name="upgrade"
        (ngModelChange)="
          getGradeType('Tankless / solar water heater', hgUpgrades.upgrade6)
        "
      />
      <label class="custom-control-label font20" for="upgrade6_mob"
        >Tankless / solar water heater</label
      >
    </label>
    <label
      class="custom-control custom-checkbox chkbox mb-2"
      for="upgrade7_mob"
      *ngIf="!propertyFlag"
    >
      <input
        type="checkbox"
        class="custom-control-input mgntp10"
        id="upgrade7_mob"
        value="hgUpgrades.upgrade7"
        [(ngModel)]="hgUpgrades.upgrade7"
        name="upgrade"
        (ngModelChange)="getGradeType('Solar panels', hgUpgrades.upgrade7)"
      />
      <label class="custom-control-label font20" for="upgrade7_mob"
        >Solar panels</label
      >
    </label>
    <label
      class="custom-control custom-checkbox chkbox mb-2"
      for="upgrade8_mob"
    >
      <input
        type="checkbox"
        class="custom-control-input mgntp10"
        id="upgrade8_mob"
        value="hgUpgrades.upgrade8"
        [(ngModel)]="hgUpgrades.upgrade8"
        name="upgrade"
        (ngModelChange)="getGradeType('None of the above', hgUpgrades.upgrade8)"
      />
      <label class="custom-control-label font20" for="upgrade8_mob"
        >None of the above</label
      >
    </label>
  </div>
  <div class="m-auto text-center">
    <p class="m-auto mt-4 text-muted tapmsg">{{ questionObj.chkboxtype }}</p>
  </div>
  <!-- <div class="col-sm-10 text-left" *ngIf="showTyping">
      <img src="assets/images/typing-animated-gif-1.gif"/>
    </div> -->
  <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width: 100%" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-2 col-2 px-0 my-auto">
      <div class="arrow_box">
        <img
          class="p-2 pl-2 ml-1"
          src="assets/images/typing-animated-gif-4.gif"
        />
      </div>
    </div>
  </div>
</div>
<!-- <div class="btm-process webview">
  <div class="text-center" *ngIf="!messagetype">
    <span><img src="assets/images/active19.png"></span>
    <h4 class="clr333 processtxt">15% Completed</h4>
  </div>
  <div class="text-center" *ngIf="messagetype">
    <span><img src="assets/images/active14.png"></span>
    <h5 class="clr333 processtxt">70% Completed</h5>
  </div>
</div> -->
